/**
 * This file contains utility functions related to Intercom integration.
 */

import React from "react";
import { IntercomContextValues, useIntercom } from "react-use-intercom";

interface IProps {
  setUseIntercomRef: (showIntercom: IntercomContextValues) => void;
}

/**
 * A component that configures the Intercom utility.
 * @param props - The component props.
 * @returns null
 */
const InnerIntercomUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
  props.setUseIntercomRef(useIntercom());
  return null;
};

let intercom: IntercomContextValues;

/**
 * Sets the reference to the Intercom context.
 * @param useIntercomRefProp - The Intercom context reference.
 */
const setUseIntercomRef = (useIntercomRefProp: IntercomContextValues) => {
  intercom = useIntercomRefProp;
};

/**
 * A component that configures the Intercom utility.
 * @returns The IntercomUtilsConfigurator component.
 */
const IntercomUtilsConfigurator = () => {
  return (
    <InnerIntercomUtilsConfigurator setUseIntercomRef={setUseIntercomRef} />
  );
};

/**
 * Constants for Intercom events.
 */
const INTERCOM_EVENTS = {
  TALK_WITH_SALES: "talkWithSales",
  BUG_ENCOUNTERED: "bugEncountered",
};

/**
 * Retrieves the Intercom context.
 * @returns The Intercom context.
 */
const getIntercom = () => {
  return intercom;
};

export const Intercom = {
  IntercomUtilsConfigurator,
  INTERCOM_EVENTS,
  getIntercom,
};
